import React, { useState } from "react";
import { SucursalesABM } from "./Sucursales/SucursalesABM";
import { SucursalesListado } from "./Sucursales/SucursalesListado";
import { type Sucursal } from "@/lib/api";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

type SucursalesView = "ABM" | "Listado";

export function SucursalesSection() {
  const [currentView, setCurrentView] = useState<SucursalesView>("Listado");
  const [selectedItem, setSelectedItem] = useState<Sucursal | null>(null);

  const handleEdit = (item: Sucursal) => {
    setSelectedItem(item);
    setCurrentView("ABM");
  };

  const handleBack = () => {
    setSelectedItem(null);
    setCurrentView("Listado");
  };

  const handleNew = () => {
    setSelectedItem(null);
    setCurrentView("ABM");
  };

  useRegisterOpcionesAbmNav(
    currentView === "ABM",
    selectedItem != null,
    handleBack
  );

  return (
    <div className="space-y-4">
      {currentView === "ABM" ? (
        <SucursalesABM
          selectedItem={selectedItem}
          onBack={handleBack}
          onSaved={handleBack}
        />
      ) : (
        <SucursalesListado onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}